import { CDN_URL } from 'constants/api';
const baseImgUrl = `${CDN_URL}/static/website_2_0/images/country-flags`;

export const countryCodeMap = [
  {
    id: 'india',
    code: '91',
    label: '+91',
    value: 'India',
    icon: `${baseImgUrl}/india.png`,
    url: `${baseImgUrl}/india.png`,
    geoIPCountryCode: 'IN',
  },
  {
    id: 'united-states-of-america',
    code: '1',
    label: '+1',
    value: 'USA',
    icon: `${baseImgUrl}/united-states-of-america.png`,
    url: `${baseImgUrl}/united-states-of-america.png`,
    geoIPCountryCode: 'US',
  },
  {
    id: 'afghanistan',
    code: '93',
    label: '+93',
    value: 'Afghanistan',
    icon: `${baseImgUrl}/afghanistan.png`,
    url: `${baseImgUrl}/afghanistan.png`,
    geoIPCountryCode: 'AF',
  },
  {
    id: 'american-samoa',
    code: '685',
    label: '+685',
    value: 'Samoa',
    icon: `${baseImgUrl}/american-samoa.png`,
    url: `${baseImgUrl}/american-samoa.png`,
    geoIPCountryCode: 'AS',
  },
  {
    id: 'argentina',
    code: '54',
    label: '+54',
    value: 'Argentina',
    icon: `${baseImgUrl}/argentina.png`,
    url: `${baseImgUrl}/argentina.png`,
    geoIPCountryCode: 'AR',
  },
  {
    id: 'australia',
    code: '61',
    label: '+61',
    value: 'Australia',
    icon: `${baseImgUrl}/australia.png`,
    url: `${baseImgUrl}/australia.png`,
    geoIPCountryCode: 'AU',
  },
  {
    id: 'austria',
    code: '43',
    label: '+43',
    value: 'Austria',
    icon: `${baseImgUrl}/austria.png`,
    url: `${baseImgUrl}/austria.png`,
    geoIPCountryCode: 'AT',
  },
  {
    id: 'bangladesh',
    code: '880',
    label: '+880',
    value: 'Bangladesh',
    icon: `${baseImgUrl}/bangladesh.png`,
    url: `${baseImgUrl}/bangladesh.png`,
    geoIPCountryCode: 'BD',
  },
  {
    id: 'belgium',
    code: '32',
    label: '+32',
    value: 'Belgium',
    icon: `${baseImgUrl}/belgium.png`,
    url: `${baseImgUrl}/belgium.png`,
    geoIPCountryCode: 'BE',
  },
  {
    id: 'bermuda',
    code: '1441',
    label: '+1441',
    value: 'Bermuda',
    icon: `${baseImgUrl}/bermuda.png`,
    url: `${baseImgUrl}/bermuda.png`,
    geoIPCountryCode: 'BM',
  },
  {
    id: 'bhutan',
    code: '975',
    label: '+975',
    value: 'Bhutan',
    icon: `${baseImgUrl}/bhutan.png`,
    url: `${baseImgUrl}/bhutan.png`,
    geoIPCountryCode: 'BT',
  },
  {
    id: 'brazil',
    code: '55',
    label: '+55',
    value: 'Brazil',
    icon: `${baseImgUrl}/brazil.png`,
    url: `${baseImgUrl}/brazil.png`,
    geoIPCountryCode: 'BR',
  },
  {
    id: 'brunei',
    code: '673',
    label: '+673',
    value: 'Brunei',
    icon: '',
    url: '',
    geoIPCountryCode: 'BN',
  },
  {
    id: 'bul',
    code: '359',
    label: '+359',
    value: 'Bulgaria',
    icon: `${baseImgUrl}/bulgaria.png`,
    url: `${baseImgUrl}/bulgaria.png`,
    geoIPCountryCode: 'BG',
  },
  {
    id: 'cambodia',
    code: '855',
    label: '+855',
    value: 'Cambodia',
    icon: `${baseImgUrl}/cambodia.png`,
    url: `${baseImgUrl}/cambodia.png`,
    geoIPCountryCode: 'KH',
  },
  {
    id: 'canada',
    code: '1',
    label: '+1',
    value: 'Canada',
    icon: `${baseImgUrl}/canada.png`,
    url: `${baseImgUrl}/canada.png`,
    geoIPCountryCode: 'CA',
  },
  {
    id: 'chile',
    code: '56',
    label: '+56',
    value: 'Chile',
    icon: `${baseImgUrl}/chile.png`,
    url: `${baseImgUrl}/chile.png`,
    geoIPCountryCode: 'CL',
  },
  {
    id: 'china',
    code: '86',
    label: '+86',
    value: 'China',
    icon: `${baseImgUrl}/china.png`,
    url: `${baseImgUrl}/china.png`,
    geoIPCountryCode: 'CN',
  },
  {
    id: 'colombia',
    code: '57',
    label: '+57',
    value: 'Colombia',
    icon: `${baseImgUrl}/colombia.png`,
    url: `${baseImgUrl}/colombia.png`,
    geoIPCountryCode: 'CO',
  },
  {
    id: 'cuba',
    code: '53',
    label: '+53',
    value: 'Cuba',
    icon: `${baseImgUrl}/cuba.png`,
    url: `${baseImgUrl}/cuba.png`,
    geoIPCountryCode: 'CU',
  },
  {
    id: 'czech-republic',
    code: '420',
    label: '+420',
    value: 'Czech Republic',
    icon: `${baseImgUrl}/czech-republic.png`,
    url: `${baseImgUrl}/czech-republic.png`,
    geoIPCountryCode: 'CZ',
  },
  {
    id: 'denmark',
    code: '45',
    label: '+45',
    value: 'Denmark',
    icon: `${baseImgUrl}/denmark.png`,
    url: `${baseImgUrl}/denmark.png`,
    geoIPCountryCode: 'DK',
  },
  {
    id: 'egypt',
    code: '20',
    label: '+20',
    value: 'Egypt',
    icon: `${baseImgUrl}/egypt.png`,
    url: `${baseImgUrl}/egypt.png`,
    geoIPCountryCode: 'EG',
  },
  {
    id: 'finland',
    code: '358',
    label: '+358',
    value: 'Finland',
    icon: `${baseImgUrl}/finland.png`,
    url: `${baseImgUrl}/finland.png`,
    geoIPCountryCode: 'FI',
  },
  {
    id: 'france',
    code: '33',
    label: '+33',
    value: 'France',
    icon: `${baseImgUrl}/france.png`,
    url: `${baseImgUrl}/france.png`,
    geoIPCountryCode: 'FR',
  },
  {
    id: 'germany',
    code: '49',
    label: '+49',
    value: 'Germany',
    icon: `${baseImgUrl}/germany.png`,
    url: `${baseImgUrl}/germany.png`,
    geoIPCountryCode: 'DE',
  },
  {
    id: 'hong-kong',
    code: '852',
    label: '+852',
    value: 'Hong Kong',
    icon: `${baseImgUrl}/hong-kong.png`,
    url: `${baseImgUrl}/hong-kong.png`,
    geoIPCountryCode: 'HK',
  },
  {
    id: 'hungary',
    code: '36',
    label: '+36',
    value: 'Hungary',
    icon: `${baseImgUrl}/hungary.png`,
    url: `${baseImgUrl}/hungary.png`,
    geoIPCountryCode: 'HU',
  },
  {
    id: 'iceland',
    code: '354',
    label: '+354',
    value: 'Iceland',
    icon: `${baseImgUrl}/iceland.png`,
    url: `${baseImgUrl}/iceland.png`,
    geoIPCountryCode: 'IS',
  },
  {
    id: 'indonesia',
    code: '62',
    label: '+62',
    value: 'Indonesia',
    icon: `${baseImgUrl}/indonesia.png`,
    url: `${baseImgUrl}/indonesia.png`,
    geoIPCountryCode: 'ID',
  },
  {
    id: 'ireland',
    code: '353',
    label: '+353',
    value: 'Ireland',
    icon: `${baseImgUrl}/ireland.png`,
    url: `${baseImgUrl}/ireland.png`,
    geoIPCountryCode: 'IE',
  },
  {
    id: 'israel',
    code: '972',
    label: '+972',
    value: 'Israel',
    icon: `${baseImgUrl}/israel.png`,
    url: `${baseImgUrl}/israel.png`,
    geoIPCountryCode: 'IL',
  },
  {
    id: 'italy',
    code: '39',
    label: '+39',
    value: 'Italy',
    icon: `${baseImgUrl}/italy.png`,
    url: `${baseImgUrl}/italy.png`,
    geoIPCountryCode: 'IT',
  },
  {
    id: 'jamaica',
    code: '876',
    label: '+876',
    value: 'Jamaica',
    icon: `${baseImgUrl}/jamaica.png`,
    url: `${baseImgUrl}/jamaica.png`,
    geoIPCountryCode: 'JM',
  },
  {
    id: 'japan',
    code: '81',
    label: '+81',
    value: 'Japan',
    icon: `${baseImgUrl}/japan.png`,
    url: `${baseImgUrl}/japan.png`,
    geoIPCountryCode: 'JP',
  },
  {
    id: 'jordan',
    code: '962',
    label: '+962',
    value: 'Jordan',
    icon: `${baseImgUrl}/jordan.png`,
    url: `${baseImgUrl}/jordan.png`,
    geoIPCountryCode: 'JO',
  },
  {
    id: 'kuwait',
    code: '965',
    label: '+965',
    value: 'Kuwait',
    icon: `${baseImgUrl}/kuwait.png`,
    url: `${baseImgUrl}/kuwait.png`,
    geoIPCountryCode: 'KW',
  },
  {
    id: 'lithuania',
    code: '370',
    label: '+370',
    value: 'Lithuania',
    icon: `${baseImgUrl}/lithuania.png`,
    url: `${baseImgUrl}/lithuania.png`,
    geoIPCountryCode: 'LT',
  },
  {
    id: 'malaysia',
    code: '60',
    label: '+60',
    value: 'Malaysia',
    icon: `${baseImgUrl}/malaysia.png`,
    url: `${baseImgUrl}/malaysia.png`,
    geoIPCountryCode: 'MY',
  },
  {
    id: 'mexico',
    code: '52',
    label: '+52',
    value: 'Mexico',
    icon: `${baseImgUrl}/mexico.png`,
    url: `${baseImgUrl}/mexico.png`,
    geoIPCountryCode: 'MX',
  },
  {
    id: 'morocco',
    code: '212',
    label: '+212',
    value: 'Morocco',
    icon: `${baseImgUrl}/morocco.png`,
    url: `${baseImgUrl}/morocco.png`,
    geoIPCountryCode: 'MA',
  },
  {
    id: 'myanmar',
    code: '95',
    label: '+95',
    value: 'Myanmar',
    icon: `${baseImgUrl}/myanmar.png`,
    url: `${baseImgUrl}/myanmar.png`,
    geoIPCountryCode: 'MM',
  },
  {
    id: 'nepal',
    code: '977',
    label: '+977',
    value: 'Nepal',
    icon: `${baseImgUrl}/nepal.png`,
    url: `${baseImgUrl}/nepal.png`,
    geoIPCountryCode: 'NP',
  },
  {
    id: 'netherlands',
    code: '31',
    label: '+31',
    value: 'Netherlands',
    icon: `${baseImgUrl}/netherlands.png`,
    url: `${baseImgUrl}/netherlands.png`,
    geoIPCountryCode: 'NL',
  },
  {
    id: 'new-zealand',
    code: '64',
    label: '+64',
    value: 'New Zealand',
    icon: `${baseImgUrl}/new-zealand.png`,
    url: `${baseImgUrl}/new-zealand.png`,
    geoIPCountryCode: 'NZ',
  },
  {
    id: 'northern-marianas-islands',
    code: '1',
    label: '+1',
    value: 'Northern Marianas Islands',
    icon: `${baseImgUrl}/northern-marianas-islands.png`,
    url: `${baseImgUrl}/northern-marianas-islands.png`,
    geoIPCountryCode: 'MP',
  },
  {
    id: 'pakistan',
    code: '92',
    label: '+92',
    value: 'Pakistan',
    icon: `${baseImgUrl}/pakistan.png`,
    url: `${baseImgUrl}/pakistan.png`,
    geoIPCountryCode: 'PK',
  },
  {
    id: 'philippines',
    code: '63',
    label: '+63',
    value: 'Philippines',
    icon: `${baseImgUrl}/philippines.png`,
    url: `${baseImgUrl}/philippines.png`,
    geoIPCountryCode: 'PH',
  },
  {
    id: 'poland',
    code: '48',
    label: '+48',
    value: 'Poland',
    icon: `${baseImgUrl}/poland.png`,
    url: `${baseImgUrl}/poland.png`,
    geoIPCountryCode: 'PL',
  },
  {
    id: 'portugal',
    code: '351',
    label: '+351',
    value: 'Portugal',
    icon: `${baseImgUrl}/portugal.png`,
    url: `${baseImgUrl}/portugal.png`,
    geoIPCountryCode: 'PT',
  },
  {
    id: 'puerto-rico',
    code: '1',
    label: '+1',
    value: 'Puerto Rico',
    icon: `${baseImgUrl}/puerto-rico.png`,
    url: `${baseImgUrl}/puerto-rico.png`,
    geoIPCountryCode: 'PR',
  },
  {
    id: 'qatar',
    code: '974',
    label: '+974',
    value: 'Qatar',
    icon: `${baseImgUrl}/qatar.png`,
    url: `${baseImgUrl}/qatar.png`,
    geoIPCountryCode: 'QA',
  },
  {
    id: 'singapore',
    code: '65',
    label: '+65',
    value: 'Singapore',
    icon: `${baseImgUrl}/singapore.png`,
    url: `${baseImgUrl}/singapore.png`,
    geoIPCountryCode: 'SG',
  },
  {
    id: 'south-africa',
    code: '27',
    label: '+27',
    value: 'South Africa',
    icon: `${baseImgUrl}/south-africa.png`,
    url: `${baseImgUrl}/south-africa.png`,
    geoIPCountryCode: 'ZA',
  },
  {
    id: 'spain',
    code: '34',
    label: '+34',
    value: 'Spain',
    icon: `${baseImgUrl}/spain.png`,
    url: `${baseImgUrl}/spain.png`,
    geoIPCountryCode: 'ES',
  },
  {
    id: 'sri-lanka',
    code: '94',
    label: '+94',
    value: 'Sri Lanka',
    icon: `${baseImgUrl}/sri-lanka.png`,
    url: `${baseImgUrl}/sri-lanka.png`,
    geoIPCountryCode: 'LK',
  },
  {
    id: 'switzerland',
    code: '41',
    label: '+41',
    value: 'Switzerland',
    icon: '',
    url: '',
    geoIPCountryCode: 'CH',
  },
  {
    id: 'thailand',
    code: '66',
    label: '+66',
    value: 'Thailand',
    icon: `${baseImgUrl}/thailand.png`,
    url: `${baseImgUrl}/thailand.png`,
    geoIPCountryCode: 'TH',
  },
  {
    id: 'turkey',
    code: '90',
    label: '+90',
    value: 'Turkey',
    icon: `${baseImgUrl}/turkey.png`,
    url: `${baseImgUrl}/turkey.png`,
    geoIPCountryCode: 'TR',
  },
  {
    id: 'ukraine',
    code: '380',
    label: '+380',
    value: 'Ukraine',
    icon: `${baseImgUrl}/ukraine.png`,
    url: `${baseImgUrl}/ukraine.png`,
    geoIPCountryCode: 'UA',
  },
  {
    id: 'united-arab-emirates',
    code: '971',
    label: '+971',
    value: 'United Arab Emirates',
    icon: `${baseImgUrl}/united-arab-emirates.png`,
    url: `${baseImgUrl}/united-arab-emirates.png`,
    geoIPCountryCode: 'AE',
  },
  {
    id: 'united-kingdom',
    code: '44',
    label: '+44',
    value: 'United Kingdom',
    icon: `${baseImgUrl}/united-kingdom.png`,
    url: `${baseImgUrl}/united-kingdom.png`,
    geoIPCountryCode: 'GB',
  },
  {
    id: 'nigeria',
    code: '234',
    label: '+234',
    value: 'Nigeria',
    icon: `${baseImgUrl}/nigeria.png`,
    url: `${baseImgUrl}/nigeria.png`,
    geoIPCountryCode: 'NG',
  },
  {
    id: 'ghana',
    code: '233',
    label: '+233',
    value: 'Ghana',
    icon: `${baseImgUrl}/ghana.png`,
    url: `${baseImgUrl}/ghana.png`,
    geoIPCountryCode: 'GH',
  },
  {
    id: 'kenya',
    code: '254',
    label: '+254',
    value: 'Kenya',
    icon: `${baseImgUrl}/kenya.png`,
    url: `${baseImgUrl}/kenya.png`,
    geoIPCountryCode: 'KE',
  },
  {
    id: 'saudi-arabia',
    code: '966',
    label: '+966',
    value: 'Saudi Arabia',
    icon: `${baseImgUrl}/saudi-arabia.png`,
    url: `${baseImgUrl}/saudi-arabia.png`,
    geoIPCountryCode: 'SA',
  },
  {
    id: 'oman',
    code: '968',
    label: '+968',
    value: 'Oman',
    icon: `${baseImgUrl}/oman.png`,
    url: `${baseImgUrl}/oman.png`,
    geoIPCountryCode: 'OM',
  },
  {
    id: 'bahrain',
    code: '973',
    label: '+973',
    value: 'Bahrain',
    icon: `${baseImgUrl}/bahrain.png`,
    url: `${baseImgUrl}/bahrain.png`,
    geoIPCountryCode: 'BH',
  },
  {
    id: 'vietnam',
    code: '84',
    label: '+84',
    value: 'Vietnam',
    icon: `${baseImgUrl}/vietnam.png`,
    url: `${baseImgUrl}/vietnam.png`,
    geoIPCountryCode: 'VN',
  },
  {
    id: 'zambia',
    code: '260',
    label: '+260',
    value: 'Zambia',
    icon: `${baseImgUrl}/zambia.png`,
    url: `${baseImgUrl}/zambia.png`,
    geoIPCountryCode: 'ZM',
  },
  {
    id: 'ethiopia',
    code: '251',
    label: '+251',
    value: 'Ethiopia',
    icon: `${baseImgUrl}/ethiopia.png`,
    url: `${baseImgUrl}/ethiopia.png`,
    geoIPCountryCode: 'ET',
  },
  {
    id: 'tanzania',
    code: '255',
    label: '+255',
    value: 'Tanzania',
    icon: `${baseImgUrl}/tanzania.png`,
    url: `${baseImgUrl}/tanzania.png`,
    geoIPCountryCode: 'TZ',
  },
  {
    id: 'lebanon',
    code: '961',
    label: '+961',
    value: 'Lebanon',
    icon: `${baseImgUrl}/lebanon.png`,
    url: `${baseImgUrl}/lebanon.png`,
    geoIPCountryCode: 'LB',
  },
  {
    id: 'sweden',
    code: '46',
    label: '+46',
    value: 'Sweden',
    icon: `${baseImgUrl}/sweden.png`,
    url: `${baseImgUrl}/sweden.png`,
    geoIPCountryCode: 'SE',
  },
  {
    id: 'romania',
    code: '40',
    label: '+40',
    value: 'Romania',
    icon: `${baseImgUrl}/romania.png`,
    url: `${baseImgUrl}/romania.png`,
    geoIPCountryCode: 'RO',
  },
  {
    id: 'south Korea',
    code: '82',
    label: '+82',
    value: 'South Korea',
    icon: `${baseImgUrl}/south-korea.png`,
    url: `${baseImgUrl}/south-korea.png`,
    geoIPCountryCode: 'KR',
  },
  {
    id: 'iraq',
    code: '964',
    label: '+964',
    value: 'Iraq',
    icon: `${baseImgUrl}/iraq.png`,
    url: `${baseImgUrl}/iraq.png`,
    geoIPCountryCode: 'IQ',
  },
  {
    id: 'norway',
    code: '47',
    label: '+47',
    value: 'Norway',
    icon: '',
    url: '',
    geoIPCountryCode: 'NO',
  },
  {
    id: 'uzbekistan',
    code: '998',
    label: '+998',
    value: 'Uzbekistan',
    icon: '',
    url: '',
    geoIPCountryCode: 'UZ',
  },
  {
    id: 'uganda',
    code: '256',
    label: '+256',
    value: 'Uganda',
    icon: '',
    url: '',
    geoIPCountryCode: 'UG',
  },
  {
    id: 'mauritius',
    code: '230',
    label: '+230',
    value: 'Mauritius',
    icon: '',
    url: '',
    geoIPCountryCode: 'MU',
  },
  {
    id: 'north_macedonia',
    code: '389',
    label: '+389',
    value: 'North Macedonia',
    icon: '',
    url: '',
    geoIPCountryCode: 'MK',
  },
  {
    id: 'democratic_republic_of_the_congo',
    code: '243',
    label: '+243',
    value: 'Democratic Republic of the Congo',
    icon: '',
    url: '',
    geoIPCountryCode: 'CD',
  },
  {
    id: 'luxembourg',
    code: '352',
    label: '+352',
    value: 'Luxembourg',
    icon: '',
    url: '',
    geoIPCountryCode: 'LU',
  },
  {
    id: 'macao',
    code: '853',
    label: '+853',
    value: 'Macao',
    icon: '',
    url: '',
    geoIPCountryCode: 'MO',
  },
  {
    id: 'mozambique',
    code: '258',
    label: '+258',
    value: 'Mozambique',
    icon: '',
    url: '',
    geoIPCountryCode: 'MO',
  },
  {
    id: 'Réunion and Mayotte',
    code: '262',
    label: '+262',
    value: 'Réunion and Mayotte',
    icon: '',
    url: '',
    geoIPCountryCode: 'MO',
  },
];

export const COUNTRY_OPTIONS = countryCodeMap.map(({ id, code }) => ({
  label: `${id}-${code}`,
  value: code,
  countryName: id,
}));
